/**
 * Mint Route - List Available Minting Dapps
 *
 * Route: /mint
 *
 * Displays a grid of all available minting dapps (internal and external)
 * that users can select to launch. Uses the same header/gradient style
 * as individual mint pages.
 *
 * @module routes/mint/index
 * @category Routes
 */

import { createFileRoute } from '@tanstack/react-router';
import MintDappsList from '@/containers/MintDappsList';
import './mint.css';

export const Route = createFileRoute('/$locale/mint/')({
  component: MintDappsListPage,
});

function MintDappsListPage() {
  return <MintDappsList />;
}
